import { CardComponentProps } from "@~/types/types";
import { useEffect } from "react";
import { useExperienceString } from "@~/flags/flags";

export function CompareCheckbox({
  product,
}: Pick<CardComponentProps, "product">) {
  const experiencesRawString = useExperienceString();

  useEffect(() => {
    if (
      !window.customElements.get("jl-compare") &&
      !document.getElementById("jl-compare-script") &&
      product.compare
    ) {
      const script = document.createElement("script");
      script.src = "/compare/compare.iife.js";
      script.id = "jl-compare-script";
      document.head.appendChild(script);

      const styles = document.createElement("link");
      styles.rel = "stylesheet";
      styles.href = "/compare/style.css";
      document.head.appendChild(styles);

      const jlCompare = document.createElement("jl-compare");
      jlCompare.setAttribute(
        "experiences-raw-string",
        experiencesRawString || "",
      );
      document.body.appendChild(jlCompare);
    }
    return () => {};
  }, []);

  if (!product.compare) {
    return null;
  }

  return (
    <jl-compare-checkbox
      data-testid="compare-checkbox"
      pim-product-id={product.aliases.pimProductId}
      title={product.title}
      ad-id={product.advertising?.associatedAdvertId}
    />
  );
}
